import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Legale } from '../../../models/legale';
import { LegaleIncaricato } from '../../../models/legale-incaricato';
import { SezioneLegali } from '../../../models/sezioni/sezione-legali';
import { LegaleAnagraficaUpdate } from './legali-anagrafica-update.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [legali-mod-anagrafica-update]',
  templateUrl: 'legali-mod-anagrafica-update.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class LegaliModAnagraficaUdate {
  @Output() onReturn: EventEmitter<Legale> = new EventEmitter<Legale>();
  @ViewChild('formAnagraficaLegali') modaleAnagrafica: LegaleAnagraficaUpdate;

  inizializza(urlUpdateAnagrafica: string, legaleIncaricato: LegaleIncaricato, sezione: SezioneLegali) {
    this.modaleAnagrafica.inizializza(urlUpdateAnagrafica, legaleIncaricato, sezione);
    openModal('modalmodanagrafica', {static: false});
  }

  createForm() {
    this.modaleAnagrafica.createForm();
  }

  manageModal(event) {
      closeModal('modalmodanagrafica');
      this.onReturn.emit(event);
  }
}
